import { jsx as l } from "react/jsx-runtime";
const r = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.516 8.016a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Zm1.5 0c0 2.757 2.243 5 5 5s5-2.243 5-5-2.243-5-5-5-5 2.243-5 5Zm6.43-2.462 1.677.445L9.12 8l2.002 2.002-1.677.444L8.06 9.061l-1.385 1.385L5 10.002 7 8 4.999 5.999l1.676-.445L8.06 6.94l1.386-1.386Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  r as CloseCircle
};
